import * as React from 'react';
import type { SVGProps } from 'react';
const SvgErrorLogs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.014 3.282c0-.43.349-.778.778-.778h12.445a.778.778 0 1 1 0 1.556H2.792a.78.78 0 0 1-.778-.778M2.014 6.913c0-.43.349-.778.778-.778h11.69a.778.778 0 0 1 0 1.556H2.792a.78.78 0 0 1-.778-.778M2.792 9.766a.778.778 0 0 0 0 1.556H7.07a.778.778 0 0 0 0-1.556zM2.014 14.176c0-.43.349-.778.778-.778h4.301a.778.778 0 0 1 0 1.556h-4.3a.78.78 0 0 1-.779-.778M13.204 11.195a.522.522 0 0 1 1.045 0v2.302a.522.522 0 0 1-1.045 0zM13.1 15.067a.627.627 0 1 1 1.253 0 .627.627 0 0 1-1.253 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.384 13.195a4.301 4.301 0 1 1 8.602 0 4.301 4.301 0 0 1-8.602 0m4.3-3.264a3.264 3.264 0 1 0 0 6.528 3.264 3.264 0 0 0 0-6.528"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgErrorLogs;
